/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_STORE } from '@moderntribe/events/data/utils';

export const SET_INITIAL_STATE = `${ PREFIX_EVENTS_STORE }/PRICE_BLOCK/SET_INITIAL_STATE`;

export const SET_PRICE_COST = `${ PREFIX_EVENTS_STORE }/SET_PRICE_COST`;

export const SET_PRICE_SYMBOL = `${ PREFIX_EVENTS_STORE }/SET_PRICE_SYMBOL`;

export const SET_PRICE_POSITION = `${ PREFIX_EVENTS_STORE }/SET_PRICE_POSITION`;

export const SET_PRICE_DESCRIPTION = `${ PREFIX_EVENTS_STORE }/SET_PRICE_DESCRIPTION`;
